<mat-form-field class="w-100" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <mat-label>{{ name }}</mat-label>
    <input
        matInput
        type="number"
        autocomplete="off"
        [(ngModel)]="value"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        [required]="isRequired"
        [disabled]="isDisabled"
        [style.text-align]="isPriceInput ? 'right' : 'left'"
        [pattern]="_regex"
        [step]="_step"
        #control="ngModel"
    />
    <mat-error *ngIf="control.hasError('required')">
        {{ 'validators.required' | translate: _locale.language }}
    </mat-error>
    <mat-error *ngIf="control.hasError('pattern')">
        {{ 'validators.patternDecimalCount' | translate: _locale.language:{ decimalCount: _decimalCount } }}
    </mat-error>
</mat-form-field>
